import { bindSwiperAutoplayToViewport } from "../utils/bind-swiper-autoplay-to-viewport.js";

/** Above 1200px: footer max-width matches `.testimonials__body` width. */
function syncTestimonialFooterWidths() {
  const wide = window.innerWidth > 1200;

  document.querySelectorAll(".testimonials__wrapper").forEach((wrapper) => {
    const body = wrapper.querySelector(".testimonials__body");
    const footer = wrapper.querySelector(".testimonials__footer");
    if (!body || !footer) return;

    footer.style.maxWidth = wide ? `${body.getBoundingClientRect().width}px` : "";
  });
}

export function testimonial() {
  if (typeof Swiper === "undefined") return;

  document.querySelectorAll(".testimonials__swiper").forEach((swiperEl) => {
    const slideCount = swiperEl.querySelectorAll(".swiper-slide").length;
    const nav = swiperEl.parentElement?.querySelector(".testimonials__nav");
    const btnPrev = nav?.querySelector(".testimonials__nav-btn--prev") ?? null;
    const btnNext = nav?.querySelector(".testimonials__nav-btn--next") ?? null;

    const hasMultipleSlides = slideCount > 1;

    if (nav) {
      nav.style.display = hasMultipleSlides ? "" : "none";
    }

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: hasMultipleSlides,
      speed: 2000,
      keyboard: {
        enabled: hasMultipleSlides,
        onlyInViewport: true,
      },
      autoplay: hasMultipleSlides
        ? {
            delay: 3500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
      navigation:
        hasMultipleSlides && btnPrev && btnNext
          ? {
              prevEl: btnPrev,
              nextEl: btnNext,
            }
          : {},
    });

    bindSwiperAutoplayToViewport(swiper);

    function updateNavState() {
      if (!btnPrev || !btnNext) return;
      if (!swiper.params.loop) {
        btnPrev.setAttribute(
          "aria-disabled",
          swiper.isBeginning ? "true" : "false",
        );
        btnNext.setAttribute("aria-disabled", swiper.isEnd ? "true" : "false");
      }
    }

    swiper.on("slideChange", updateNavState);
    updateNavState();

    swiper.on("slideChangeTransitionEnd", syncTestimonialFooterWidths);
  });

  syncTestimonialFooterWidths();
  window.addEventListener("resize", syncTestimonialFooterWidths);
}
